"use strict";
import lightestStyles from "./src/theme-lightest.css.js";
import { Theme } from "./src/Theme.dev.js";
import "./core.dev.js";
Theme.registerThemeFragment("lightest", "color", lightestStyles);
//# sourceMappingURL=theme-lightest.dev.js.map
